import React, { useCallback, useRef, useState } from 'react';
import { useSalvaCampo } from './salvaCampo';
import { messaggioDa } from './notifiche';
import { useUscitaProtetta } from './uscitaProtetta';
import { visiteAPI } from '../services/api';

/**
 * Un MODULO della procedura (parametri, note, zone, fotografie) che si
 * salva da solo quando si esce da un suo campo (regola di Alex del 24
 * settembre 2026; schermate decise da Alex lo stesso giorno). Niente
 * «Salva»: la matita apre, «Chiudi» chiude.
 *
 * La rotta del modulo scrive il contenuto INTERO (un jsonb): all'uscita da
 * un campo si manda il contenuto com'e' adesso, ma solo se e' diverso
 * dall'ultimo salvato. Il server fa lo stesso confronto per conto suo.
 * Sotto c'e' il meccanismo dell'anamnesi (utils/salvaCampo.js): una coda,
 * «non salvato» che non sparisce, nessun nuovo tentativo automatico.
 */
export function useSalvaModulo(modulo, onSalvato) {
    const ultimo = useRef(JSON.stringify(modulo.contenuto || {}));
    const [errore, setErrore] = useState(null);
    const scrivi = useCallback(async (_campo, contenuto) => {
        try {
            await visiteAPI.updateModulo(modulo.id, { titolo: modulo.titolo, contenuto, ordine: modulo.ordine });
            ultimo.current = JSON.stringify(contenuto);
            setErrore(null);
        } catch (e) {
            setErrore(messaggioDa(e, 'il salvataggio non è riuscito'));
            throw e;
        }
    }, [modulo.id, modulo.titolo, modulo.ordine]);
    const { stato, salva, nonSalvati } = useSalvaCampo(scrivi, onSalvato);
    useUscitaProtetta(nonSalvati.length > 0, nonSalvati.length || null);

    const esci = (contenuto) => {
        if (JSON.stringify(contenuto) === ultimo.current) return;     // non e' cambiato
        salva('contenuto', contenuto);
    };
    return { esci, riprova: (c) => salva('contenuto', c), stato: stato.contenuto, errore };
}

/** «salvataggio…», «✓ salvato», o il motivo e «Riprova»: lo stesso per tutti i moduli. */
export const StatoModulo = ({ auto, contenuto }) => {
    if (auto.stato === 'in_corso') return <span className="modulo-stato">salvataggio…</span>;
    if (auto.stato === 'salvato') return <span className="modulo-stato modulo-stato-ok">✓ salvato</span>;
    if (auto.stato === 'non_salvato') {
        return (
            <div className="modulo-stato-errore" role="alert">
                <span>Non salvato: {auto.errore || 'il salvataggio non è riuscito'}. Il testo è ancora nel campo.</span>
                <button type="button" onClick={() => auto.riprova(contenuto)}>Riprova</button>
            </div>
        );
    }
    return null;
};
